import { computeExhibitLabels, formatExhibitLabel } from "./exhibitLabels";
import type { ExhibitScheme, FsNode } from "./types";

export type PreviewRow = {
  id: string;
  name: string;
  depth: number;
  folder: boolean;
  label: string;
};

/** Two folders of two files each, the second holding one nested folder. */
const SAMPLE: [id: string, parent: string | null, name: string][] = [
  ["identity", null, "Identity Documents"],
  ["passport", "identity", "Passport"],
  ["birth", "identity", "Birth Certificate"],
  ["awards", null, "Awards"],
  ["award", "awards", "Award Letter"],
  ["press", "awards", "Press Coverage"],
  ["judging", "awards", "Judging"],
  ["invite", "judging", "Panel Invitation"]
];

const FOLDERS = new Set(["identity", "awards", "judging"]);

const SAMPLE_NODES = SAMPLE.map(
  ([id, parent, name], index) =>
    ({
      id,
      parent_id: parent,
      kind: FOLDERS.has(id) ? "folder" : "file",
      name,
      sort_key: String(index).padStart(4, "0"),
      packet_inclusion: "included",
      exhibit_numbering: "numbered"
    } as FsNode)
);

const depthOf = (id: string): number => {
  const parent = SAMPLE.find(([nodeId]) => nodeId === id)?.[1] ?? null;
  return parent ? depthOf(parent) + 1 : 0;
};

/** The sample tree as the scheme labels it, in tree order. */
export const previewRows = (scheme: ExhibitScheme): PreviewRow[] => {
  const labels = computeExhibitLabels(SAMPLE_NODES, scheme);
  return SAMPLE_NODES.map((node) => ({
    id: node.id,
    name: node.name,
    depth: depthOf(node.id),
    folder: FOLDERS.has(node.id),
    label: formatExhibitLabel(labels[node.id], scheme)
  }));
};
